(function (oneWorldView, $) {
  var imageElements;
  var slider;
  var endOfArticleSymbol;
  var zoomImageElement;
  var initialImageIndex;

  var oneWorldSection;
  var oneWorldSectionHeight;
  var oneWorldSectionOffsetTop;

  oneWorldView.init = function () {
    oneWorldSection = $("#one-world-section");
    imageElements = $(".one-world-grid-link");
    endOfArticleSymbol = $("#one-world-end-of-article-symbol-image");

    imageElements.click(initialiseZoom);

    initialiseSlider();

    calculateGeometry();
    setTimeout(calculateGeometry, 2000);
    setTimeout(calculateGeometry, 6000);
    setInterval(calculateGeometry, 18000);
    wireEvents();
  };

  function initialiseSlider() {
    slider = tns({
      container: ".one-world-grid",
      /*fixedWidth:200,*/
      autoWidth: false /* because we want 2 slides shown at once at times */,
      slideBy: 1,
      items: 2,
      autoplay: true, // on the product detail page, autoplay seems to go haywire after dragging with mouse, so keep it off
      autoplayTimeout: 3000,
      autoplayHoverPause: false,
      autoplayButtonOutput: "",
      controls: false,
      nav: false /* This turns off the nav dots */,
      lazyload: false,
      mouseDrag: false,
      responsive: {
        1700: { items: 6 },
        1400: { items: 5 },
        1000: { items: 4 },
        700: { items: 3 },
      },
      /*lazyloadSelector:'.inspired__image'*/
      /*center:true,*/
      /*mouseDrag:true*/ /* MouseDrag doesn't work very well when the items are anchor linked */
    });

    slider.elIsDragging = false;
    slider.events.on("dragMove", function () {
      slider.elIsDragging = true;
    });

    slider.events.on("dragEnd", function () {
      slider.elIsDragging = false;
    });
  }

  function initialiseZoom(evt) {
    if (slider.elIsDragging === true) {
      return;
    }

    var zoomOverlayElement = $($("#zoom-overlay-template").html());

    $("body").append(zoomOverlayElement);

    zoomOverlayElement.show();

    initialImageIndex = $.inArray(evt.currentTarget, imageElements);

    $("#zoom-overlay-close").click(function () {
      zoomOverlayElement.remove();
    });

    $("#zoom-overlay-nav-next").click(function () {
      initialImageIndex = (initialImageIndex + 1).mod(imageElements.length);
      navigateToImageIndex(initialImageIndex);
    });

    $("#zoom-overlay-nav-previous").click(function () {
      initialImageIndex = (initialImageIndex - 1).mod(imageElements.length);
      navigateToImageIndex(initialImageIndex);
    });

    zoomImageElement = $("#zoom-overlay-image");

    navigateToImageIndex(initialImageIndex);
  }

  function navigateToImageIndex(index) {
    zoomImageElement.attr("src", "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="); // clear the image for a second
    var imgSrc = $(imageElements[index]).data("zoom-src");
    zoomImageElement.attr("src", imgSrc);

    // try to preload the next one
    if (index < imageElements.length) {
      imgSrc = $(imageElements[index + 1]).data("zoom-src");
      el.Utils.preloadImage(imgSrc);
    }
  }

  function wireEvents() {
    el.documentElement.on("WINDOW_SCROLL_EVENT", function (evt, windowScrollTop) {
      var sectionOffset = windowScrollTop - oneWorldSectionOffsetTop + el.windowHeight;

      if (el.windowWidth < 768 || sectionOffset < 0 || sectionOffset > oneWorldSectionHeight * 2) {
        endOfArticleSymbol.transit({ x: 0, rotate: "0deg" }, 0, "linear");
        return;
      }

      var offsetBeyondBottomOfSection =
        windowScrollTop + el.windowHeight - oneWorldSectionOffsetTop - oneWorldSectionHeight;

      endOfArticleSymbol.transit(
        { x: offsetBeyondBottomOfSection, rotate: offsetBeyondBottomOfSection + "deg" },
        0,
        "linear",
      );
    });
  }

  function calculateGeometry() {
    if (el.windowWidth >= 768) {
      oneWorldSectionHeight = oneWorldSection.height();
      oneWorldSectionOffsetTop = oneWorldSection.offset().top;
    }
  }
})((window.el.OneWorldView = window.el.OneWorldView || {}), jQuery);
